<template>
    <blur-modal
        :is-open="inspectModalShown"
        :always-open="false"
        :absolute-header="true"
        :aria-label="`Inspect ${inspectModalComponent.description[0].name}`"
        :is-inspect-modal="true"
        @closed="closeModal"
        @actuallyClosed="closeForReal"
        class="cz2__sb-inspect-modal"
    >
        <div class="inspect-modal__content">
            <p class="cz2__sr-only">
                {{ $t('SR_PREVIEW_ROTATE_INSTRUCTIONS') }}
            </p>

            <model-preview
                v-if="inspectModalShown"
                :component="inspectModalComponent"
            />

            <model-preview-controls v-if="!isKiosk" />

            <div class="cz2__modal-popup__actions">
                <sb-button
                    variant="primary"
                    heightVariant="large"
                    @click="closeModal"
                >
                    <span>
                        {{ $t('ACTION_OKAY') }}
                    </span>
                </sb-button>
            </div>
        </div>
    </blur-modal>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__sb-inspect-modal {
            top: 0;
            padding: 50px 0px 40px;

            @include respond-above(lg) {
                padding: 50px 0 50px;
            }

            background-size: 50%;
            background-position: center;
            background-repeat: repeat;

            background-image: url('../assets/images/branded/sb-final/SB-Background-Pattern-1_M@2x.jpg');

            @include respond-above(lg) {
                background-image: url('../assets/images/branded/sb-final/SB-Background-pattern-2_D@2x.jpg');
            }

            background-size: cover;

            background-color: transparent;

            position: absolute;
            border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_M@2x.webp');

            border-width: 40px;
            border-image-width: 40px;
            border-image-slice: 80 fill;
            border-image-repeat: stretch;

            height: 100%;
            width: 100%;

            @include respond-above(lg) {
                border-image-source: url('../assets/images/branded/sb-final/SB-Border 3_D@2x.webp');
                height: 100%;
                width: 100%;
                border-width: 70px;
                border-image-width: 70px;
                border-image-slice: 140 fill;
                border-image-repeat: stretch;
            }

            .cz2__modal-popup__actions {
                margin-top: 40px;

                margin-left: auto;
                margin-right: auto;
                width: 220px;

                @include respond-above(sm) {
                    width: 280px;
                }
            }

            .cz2__blur-modal-header.absolute {
                top: 0;
            }

            .cz2__blur-modal-close {
                position: absolute;

                right: 40px;
                top: 0px !important;

                @include respond-above(lg) {
                    right: 50px;
                    top: 75px !important;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__sb-inspect-modal {
            background-image: url('../assets/images/branded/sb-final/SB-Background-pattern-2_K@2x.jpg');
            .cz2__blur-modal-close {
                top: 16px !important;
            }
        }
    }

    #cz2.cz2.cz2__is-sb {
        .cz2__sb-inspect-modal {
            .cz2__blur-modal-close {
                top: -8px !important;
                right: 32px !important;
                @include respond-above(sm) {
                    top: 16px !important;
                    right: -16px !important;
                }
                @include respond-above(lg) {
                    right: 12px !important;
                    top: 40px !important;
                }
            }
            .cz2__modal-popup__actions {
                margin-top: 20px;
            }
        }
    }
</style>

<script>
    import SbButton from './SbButton.vue';
    import BlurModal from './ui/BlurModal.vue';

    import ModelPreview from './ModelPreview.vue';
    import ModelPreviewControls from './ModelPreviewControls.vue';

    export default {
        components: {
            SbButton,
            BlurModal,
            ModelPreview,
            ModelPreviewControls,
        },

        data() {
            return {
                tryClosing: false,
            };
        },

        computed: {
            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            inspectModalShown() {
                if (this.tryClosing) {
                    return false;
                }

                return this.$store.state.inspectModalShown;
            },

            inspectModalComponent() {
                return this.$store.state.inspectModalComponent;
            },
        },

        methods: {
            closeModal() {
                this.tryClosing = true;
            },

            closeForReal() {
                this.$store.dispatch('setInspectModalComponent', null);
                this.$store.dispatch('showInspectModal', false);
            },
        },
    };
</script>
